{
  "sourceTitle": "Nouvelle équipe de bénévoles",
  "sourceDescription": "Regroupez les bénévoles en équipes pour organiser leurs rôles, leurs invitations et leurs formations.",
  "volunteeringIcon": "Bénévolat",
  "unavailable": "Les méthodes de création indisponibles peuvent nécessiter de connecter un fournisseur externe dans <link>Connexions</link>",
  "createInSalt": "Créer dans Salt",
  "createInSaltDescription": "Créer une nouvelle équipe à partir de zéro.",
  "saltLogo": "Salt",
  "importTitle": "Importer depuis Planning Center",
  "importDescription": "Importez une équipe Planning Center existante pour commencer rapidement. Les bénévoles ajoutés après l'importation ne seront pas synchronisés.",
  "planningCenterLogo": "Planning Center",
  "detailsTitle": "Nouvelle équipe",
  "namePlaceholder": "Nom de l'équipe",
  "nameLabel": "Nom de l'équipe",
  "detailsFootnote": "Vous pourrez ajouter des rôles et inviter des bénévoles une fois l'équipe créée.",
  "create": "Créer l'équipe",
  "creating": "Création…",
  "createFailed": "Impossible de créer cette équipe pour le moment.",
  "loadTeamsFailed": "Impossible de charger vos équipes Planning Center pour le moment.",
  "alreadyImported": "Cette équipe a déjà été importée.",
  "importFailed": "Impossible d'importer cette équipe pour le moment.",
  "importedTitle": "{{team}} a été importée",
  "importedVolunteers_one": "{{count}} bénévole",
  "importedVolunteers_other": "{{count}} bénévoles",
  "importedRoles_one": "{{count}} rôle",
  "importedRoles_other": "{{count}} rôles",
  "importedSummary": "{{volunteers}} et {{roles}} ont été ajoutés depuis Planning Center.",
  "unmatched_one": "{{count}} personne de cette équipe n'a pas été ajoutée, car elle n'est pas encore dans Salt. Importez vos personnes depuis Planning Center dans l'onglet <link>Personnes</link>, puis invitez-les dans cette équipe.",
  "unmatched_other": "{{count}} personnes de cette équipe n'ont pas été ajoutées, car elles ne sont pas encore dans Salt. Importez vos personnes depuis Planning Center dans l'onglet <link>Personnes</link>, puis invitez-les dans cette équipe.",
  "goToTeam": "Aller à l'équipe",
  "loadingTeams": "Chargement de vos équipes Planning Center…",
  "noTeams": "Votre compte Planning Center ne contient aucune équipe active.",
  "createInSaltInstead": "Créer plutôt une équipe dans Salt",
  "chooseTeam": "Choisissez une équipe à copier dans Salt. Ses postes deviennent des rôles, et ses membres sont associés aux personnes déjà présentes dans Salt.",
  "filterPlaceholder": "Filtrer les équipes",
  "noFilterMatches": "Aucune équipe ne correspond à ce filtre.",
  "otherTeams": "Autres équipes",
  "imported": "Importée",
  "importFootnote": "Une copie unique : l'équipe ne restera pas synchronisée avec Planning Center, et aucune nouvelle personne n'est créée.",
  "import": "Importer l'équipe",
  "importNamed": "Importer {{team}}",
  "importing": "Importation…"
}
